// components/PersonalizationFooter.tsx

import React from 'react';
import { AngleLeftIcon } from '@/utils/svgIcons';
import CustomToast from '../CustomToast';
import toast from 'react-hot-toast';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

interface Option {
  id: string;
  label: string;
  value: string;
  completed: boolean;
}

interface Props {
  step: any;
  activeOption: any;
  options: any[];
  childName: any;
  inputAge: any;
  childgender: any;
  inputDedication: any;
  inputCover: any;
  inputPackaging: any;
  is_edit: any;
  priceInPersonalize: any;
  inputs: any;
  inputValues: any;
  settings: any;
  setStep: any;
  setActiveOption: any;
  setNameModal: any;
  setDedicationModal: any;
  setCoverModal: any;
  setPackageModal: any;
  setConfirmCart: any;
  setPersonalizeModal: any;
  updateProductData: any;
  handleNextStep: any;
  handleSave: any;
  addToCart: any;
  priceSymbol: any;
  showPackagingOption: any; // Make sure this prop is passed
}

const PersonalizationFooter: React.FC<Props> = ({
  step,
  activeOption,
  options,
  childName,
  inputAge,
  childgender,
  inputDedication,
  inputCover,
  inputPackaging,
  is_edit,
  priceInPersonalize,
  inputs,
  inputValues,
  settings,
  setStep,
  setActiveOption,
  setNameModal,
  setDedicationModal,
  setCoverModal,
  setPackageModal,
  setConfirmCart,
  setPersonalizeModal,
  updateProductData,
  handleNextStep,
  handleSave,
  addToCart,
  priceSymbol,
  showPackagingOption // Get the prop
}) => {
  // Filter out hidden packaging option from visible options
  const visibleOptions = options.filter(opt => 
    !(!showPackagingOption && opt.id === 'packaging')
  );
  
  // Also create filtered options for completion checking (excluding hidden packaging)
  const filteredOptionsForCompletion = options.filter(opt => 
    !(!showPackagingOption && opt.id === 'packaging')
  );
  
  let totalOptions = visibleOptions.length;
  let completedCount = visibleOptions.filter(option => option.completed).length;
  const {t} = useTranslation('personalizeModal');
  const {locale} = useRouter();
  
  return (
    <div className={`border-t px-4 ${(step === 'review') ? 'pb-6 lg:pb-4' : ''} bg-white shadow-[0_-2px_16px_0_rgba(14,30,37,0.3)] lg:flex lg:flex-col lg:items-center lg:justify-center`}>
        {(step != 'info' && step === 'review') && (
          <div 
            className="w-full overflow-x-auto my-4 scrollbar-hide lg:max-w-3xl"
            dir={locale === 'ar' ? 'rtl' : 'ltr'}
          >
              <div 
                className={`flex items-center gap-4 px-4 min-w-max lg:hidden overflow-x-auto ${
                  locale === 'en' ? 'justify-end' : 'flex-row justify-start'
                }`}
                dir={locale === 'ar' ? 'rtl' : 'ltr'}
                id='mobile-view-personalize-options'
              >
            {visibleOptions.map(opt => {
              if (opt.id === 'name') return null;
              if (opt.id === 'age') return null;
              if (opt.id === 'gender') return null;

              return (
                <button
                  key={opt.id}
                  onClick={() => {
                    setStep('edit');
                    setActiveOption(opt.id);
                  }}
                  className={`h-20 w-full px-3 py-2 rounded-lg whitespace-nowrap text-sm font-normal flex flex-col justify-center gap-2 ${
                    activeOption === opt.id || opt.completed
                      ? 'bg-[#0CDFBF] border-[1px] border-[#0CDFBF]'
                      : 'bg-white border-[1px] border-[#B0BAC8]'
                  }`}
                >
                  <p>{opt.label}</p>
                  <div className='flex items-center mx-auto gap-2'>
                    {opt.completed === true ? (
                      <div className='w-4 h-4 flex justify-center items-center bg-primary-500 rounded-full'>
                        <svg
                          width="12"
                          height="10"
                          viewBox="0 0 12 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 5.69922L3.70368 8.64736C4.1159 9.09686 4.83101 9.07584 5.21611 8.60291L11 1.5"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                      </div>
                    ) : (
                      <div
                        className={`w-4 h-4 rounded-full ${
                          activeOption === opt.id ? 'bg-[#FFFFFF]' : 'bg-[#0CDFBF]'
                        }`}
                      />
                    )}
                    <p className='text-base font-light truncate leading-[1.6]'>
                      {opt.id === 'child' ? (
                        [childName, inputAge, childgender === 'Male' && locale === 'ar' ? 'ولد' : childgender === 'Male' && locale === 'en' ? 'Boy' : childgender === 'Female' && locale === 'ar' ? 'بنت' : childgender === 'Female' && locale === 'en' ? 'Girl' : '']
                          .filter(Boolean)
                          .join(', ')
                      ) : opt.id === 'dedication' ? (
                        `${opt.value !='' ? opt.value.split(' ').slice(0, 2).join(' ') : opt.value}`
                      ) : (
                        opt.value
                      )}
                    </p>
                  </div>
                </button>
              );
            })}
              </div>
              <div className='w-full flex items-center justify-center gap-4' dir={`${locale === 'ar' ? 'rtl' : 'ltr'}`}>
                <div className="hidden lg:flex gap-4 items-center min-w-max" >
              {visibleOptions.map(opt => {
                if (opt.id === 'name') return null;
                if (opt.id === 'age') return null;
                if (opt.id === 'gender') return null;

                return (
                  <button
                    key={opt.id}
                    data-testid={`option-${opt.id}`}
                    onClick={() => {
                      if(opt.id === 'name' || opt.id === 'age' || opt.id === 'gender' || opt.id === 'child')
                        setNameModal(true);
                      else if(opt.id === 'dedication')
                        setDedicationModal(true);
                      else if(opt.id === 'cover')
                        setCoverModal(true)
                      else if(opt.id === 'packaging' && showPackagingOption) // Only handle if shown
                        setPackageModal(true);
                    }}
                    className={`h-16 w-full px-3 py-2 rounded-lg whitespace-nowrap text-sm font-normal flex flex-col justify-center gap-2 ${
                      activeOption === opt.id || opt.completed
                        ? 'bg-[#0CDFBF] border-[1px] border-[#0CDFBF]'
                        : 'bg-white border-[1px] border-[#B0BAC8]'
                    }`}
                  >
                    <p>{opt.label}</p>
                    <div className='flex items-center mx-auto gap-2'>
                      {opt.completed === true ? (
                        <div className='w-4 h-4 flex justify-center items-center bg-primary-500 rounded-full'>
                          <svg
                            width="12"
                            height="10"
                            viewBox="0 0 12 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 5.69922L3.70368 8.64736C4.1159 9.09686 4.83101 9.07584 5.21611 8.60291L11 1.5"
                              stroke="white"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </svg>
                        </div>
                      ) : (
                        <div
                          className={`w-4 h-4 rounded-full ${
                            activeOption === opt.id ? 'bg-[#FFFFFF]' : 'bg-[#0CDFBF]'
                          }`}
                        />
                      )}
                      <p className='text-base font-light  truncate leading-[1.6]'>
                        {opt.id === 'child' ? (
                          [childName, inputAge, childgender === 'Male' && locale === 'ar' ? 'ولد' : childgender === 'Male' && locale === 'en' ? 'Boy' : childgender === 'Female' && locale === 'ar' ? 'بنت' : childgender === 'Female' && locale === 'en' ? 'Girl' : '']
                            .filter(Boolean)
                            .join(', ')
                        ) : opt.id === 'dedication' ? (
                          `${opt.value !='' ? opt.value.split(' ').slice(0, 2).join(' ') : opt.value}`
                        ) : (
                          opt.value
                        )}
                      </p>
                    </div>
                  </button>
                );
              })}
              </div>
              <p className="hidden lg:block text-sm text-[#546A88]">
                {`(${completedCount}/${totalOptions})`}
              </p>
              </div>
          </div>
        )}
        {step !== 'info' && (
          <>
          {step === 'review' && (
            <p className="w-full flex items-center justify-center mb-2 lg:hidden text-sm text-[#546A88]">
              {`(${completedCount}/${totalOptions})`}
            </p>
          )}
          <button id="personalize-modal-footer-continue-button" className={`w-full lg:max-w-xl text-white p-3 rounded-md bg-primary ${step === 'review' ? 'my-0' : 'my-3'} font-medium`} onClick={()=>{
          if((step === 'edit') && (activeOption === 'child') ){
            if (childName === '' || !isNaN(Number(childName))) {
              toast.custom((tEl) => (
                <CustomToast type="error" t={tEl} message={`${t('enterChildNameNotebook')}`} />
              ));
              return;
            }
            if(childgender === '')
            {
              toast.custom((tEl) => <CustomToast type='error' t={tEl} message={`${t('enterChildGenderError')}`} />);
              return
            }
            updateProductData(
              Object.fromEntries(
                Object.keys(inputs)
                  .filter(key => {
                    const value = inputValues[key];
                    return value !== null && value !== undefined && String(value).trim() !== '';
                  })
                  .map(key => [key, inputValues[key]])
              )
            );
            handleNextStep();
            setDedicationModal(true);
          }else if(step === 'edit' && activeOption === 'dedication'){
            updateProductData({dedication: inputDedication});
            handleSave();
          }else if(step === 'edit' && activeOption === 'cover'){
            updateProductData({cover: inputCover});
            handleSave();
          }else if(step === 'edit' && activeOption === 'packaging' && showPackagingOption) {
            updateProductData({
              packaging: inputPackaging === false ? {
                name: 'No-Packaging',
                price: 0
              } : {
                name: 'Packaging',
                price: settings?.packaging_price
              }
            });
            handleSave();
          }else {
            // Use filteredOptionsForCompletion instead of options
            if (filteredOptionsForCompletion.every(option => option.completed) && is_edit === '0') {
              setConfirmCart(true);
            } else if (filteredOptionsForCompletion.every(option => option.completed) && is_edit === '1') {
              addToCart();
            } else {
              const firstIncomplete = filteredOptionsForCompletion.find(option => !option.completed);
              if (firstIncomplete) {
                const isMobileOrTablet = typeof window !== 'undefined' && window.innerWidth <= 1024;
                if (isMobileOrTablet) {
                  setStep('edit');
                  setActiveOption(firstIncomplete.id);
                } else {
                  if(firstIncomplete.id === 'dedication')
                    setDedicationModal(true);
                  else if(firstIncomplete.id === 'cover')
                    setCoverModal(true);
                  else if(firstIncomplete.id === 'packaging' && showPackagingOption)
                    setPackageModal(true)
                }
              }
            }
          }
        }}
        dir={`${locale === 'ar' ? 'rtl' : 'ltr'}`}>
          {/* Use filteredOptionsForCompletion for button text logic too */}
          {filteredOptionsForCompletion.every(option => option.completed)
            ? is_edit === '1'
              ? `${t('completeEdit')} - ${priceInPersonalize}${priceSymbol}`
              : `${t('addToCartButtonText')} - ${priceInPersonalize}${priceSymbol}`
            : step === 'review' ? `${t('continue')} - ${priceInPersonalize}${priceSymbol} `: `${t('continue')}`}
        </button>
          </>
        )}
        {(step === 'info' && (activeOption === '' || activeOption === 'name')) && (
          <button className={`block lg:hidden my-4 w-full lg:max-w-xl text-white p-4 rounded-md bg-primary font-medium`} onClick={()=>{
            const filledInputs = Object.keys(inputs).filter(key => {
              const value = inputValues[key];
              return value !== null && value !== undefined && String(value).trim() !== '';
            });

            if (filledInputs.length < Object.keys(inputs).length) {
              toast.custom(tEl => (
                <CustomToast t={tEl} type="error" message={`${t('enterAllDetailsError')}`} />
              ));
              return;
            }
            updateProductData(
              Object.fromEntries(
                Object.keys(inputs)
                  .filter(key => {
                    const value = inputValues[key];
                    return value !== null && value !== undefined && String(value).trim() !== '';
                  })
                  .map(key => [key, inputValues[key]])
              )
            );
            handleNextStep();
            }}>
            {`${t('continue')} - ${priceInPersonalize}${priceSymbol} `}
        </button>
        )}
        {step === 'review' && (
          <button className={`mt-2 lg:mt-4 text-primary-500 text-sm font-medium ${locale === 'ar' ? 'flex' : 'flex flex-row-reverse'} items-center justify-center w-full text-center`} onClick={()=>setPersonalizeModal(false)}>
            {t('infoStepBackButton')}
          <span className={`${locale === 'ar' ? 'mr-3':'ml-3 rotate-180'}`}> 
            <AngleLeftIcon/>
          </span>
        </button>
        )}
      </div>
  );
};

export default PersonalizationFooter;